import { configureStore } from '@reduxjs/toolkit'

import globalSlice from './reducers/global'
import globalSyncMiddleware from './reducers/globalSyncMiddleware'

import userDetailsSlice  from './reducers/user/user'
import pettyCashSlice  from './reducers/pettycash/pettycash'
import userListSlice  from './reducers/listUser/listUser'
import invoiceBookingPIWiseSlice from './reducers/invoiceBooking/invoiceBooking'
import adminAccountBuyerSlice from "./reducers/adminAccountBuyer/adminAccountBuyer";
import adminAccountsBuyerSlice from "./reducers/adminAccountBuyer/adminAccountsBuyer";
import companyListSlice  from './reducers/companyList/comapnyList'
import requirementSlice from './reducers/Requirement/requirement'
import commonSlice  from './reducers/common'
import materialMasterSlice from './reducers/materialMaster/materialMaster'
import materialMasterTempSlice from "./reducers/materialMaster/materialMasterTemp"
import menuSlice from './reducers/menu/menu'
import commonToast from './reducers/toast/toast'
import vendorPaymentSellerPOSlice from './reducers/vendorPayment/vendorPayment'
import buyerCreditNotesSlice from './reducers/buyerCreditNote/buyerCreditNote'
import vendorPaymentCashFlowSlice from './reducers/cashFlow/cashFlow'
import vendorPaymentPettyCashSlice from './reducers/vendorPaymentPettyCash/vendorPaymentPettyCash'
import vendorPaymentNonCreditSlice from './reducers/vendorPaymentNonCredit/vendorPymentNonCredit'
import vendorPaymentsChequeSlice from './reducers/vendorPaymentCheque/vendorPaymentCheque'
import sellerDebitNoteSlice from './reducers/sellerDebitNote/sellerDebitNote'
import vendorPaymentSlice from './reducers/vendorPayment/vendorPayment'
import approvalSlice  from './reducers/approvalData/approvalData'
import ticketSlice from './reducers/tickets/tickets'
import buyerPOSlice from './reducers/buyerPO/buyerPO'
import getCashFlowDataSlice from './reducers/cashFlowCompanyData/cashFlowData'
import olddispatchSlice from './reducers/sellerPO/sellerPO'
import buyerDashboardRequirementSlice  from './reducers/buyerDashboard/buyerDashboardRequirement'
import consumerHistorySlice from './reducers/consumerHistory/consumerHistory'
import orderHistorySlice from './reducers/orderHistory/orderHistory'
import stockMovesSlice from './reducers/stock/stockMovement'
import stockSnapshotSlice from './reducers/stock/stockSnapshot'
import stockReportSlice from './reducers/stock/stockReport'
import buyerRateContractSlice from './reducers/buyerRateContract/buyerRateContract'
import pettyCashAccountsSlice  from './reducers/pettyCashAccounts/pettyCashAccounts'
import sellerSearchSlice  from './reducers/sellerSearch/sellerSearch'
import permissionsSlice from './reducers/permissions/permissions'
import followUpSlice from './reducers/followUp/followup'
import inwardSlice from './reducers/inward/inward'
import dispatchSlice from './reducers/dispatch/dispatch'
import emergencyMessagesSlice from './reducers/adminNotificationMessages/adminNotificationMessages';
import notificationsSlice from './reducers/notifications/notifications'
import buyerOrderHistorySlice from './reducers/buyerOrderHistory/buyerPO'
import processLineItemsSlice from './reducers/processLineItems/processLineItems'
import processLinesSlice from './reducers/processLines/processLines'
import processLineStatusSlice from './reducers/processLineStatus/processLineStatus'
import invoiceVerificationSlice from './reducers/invoiceVerification/invoiceVerification'
import vendorRateContractItemsSlice from './reducers/vendorRateContractItems/vendorRateContractItems'
import vmiSlice from './reducers/vmi/vmi'


export const store = configureStore({
    reducer: {
        userDetails: userDetailsSlice,
        pettyCash : pettyCashSlice,
        users: userListSlice,
        invoiceBookingPIWise: invoiceBookingPIWiseSlice,
        adminAccountBuyerSlice: adminAccountBuyerSlice,
        adminAccountsBuyerSlice: adminAccountsBuyerSlice,
        companies: companyListSlice,
        requirements: requirementSlice,
        requirementDashboard: buyerDashboardRequirementSlice,
        common : commonSlice,
        materialMaster : materialMasterSlice,
        materialMasterTemp: materialMasterTempSlice,
        menu: menuSlice,
        toast: commonToast,
        vendorPaymentsSellerPO : vendorPaymentSellerPOSlice,
        vendorPaymentsNonCredit : vendorPaymentNonCreditSlice,
        vendorPaymentsCheque: vendorPaymentsChequeSlice,
        vendorPaymentsCashFlow : vendorPaymentCashFlowSlice,
        vendorPaymentsPettyCash : vendorPaymentPettyCashSlice,
        sellerDebitNotes : sellerDebitNoteSlice,
        buyerCreditNotes : buyerCreditNotesSlice,
        vendorPayments : vendorPaymentSlice,
        approvalData: approvalSlice,
        getCashFlowData : getCashFlowDataSlice,
        ticketsData: ticketSlice,
        buyerPOData : buyerPOSlice,
        // dispatchData : dispatchSlice,
        dispatchData : olddispatchSlice,
        consumerHistory : consumerHistorySlice,
        orderHistory: orderHistorySlice,
        stockMoves: stockMovesSlice,
        stockSnapshot: stockSnapshotSlice,
        buyerRateContract: buyerRateContractSlice,
        pettyCashAccounts : pettyCashAccountsSlice,
        sellerSearchData : sellerSearchSlice,
        stockReport: stockReportSlice,
        permissions: permissionsSlice,
        // sellerPO: sellerPOSlice,
        // sellerPOItemsData: sellerPOItemSlice
        followUp: followUpSlice,
        inward: inwardSlice,
        dispatch: dispatchSlice,
        permissions: permissionsSlice, 
        emergencyMessages: emergencyMessagesSlice,
        notifications: notificationsSlice,
        buyerOrderHistory: buyerOrderHistorySlice,
        processLineItems: processLineItemsSlice,
        processLines: processLinesSlice,
        processLineStatus: processLineStatusSlice,
        invoiceVerification: invoiceVerificationSlice,
        global: globalSlice,
        vendorRateContractItems: vendorRateContractItemsSlice,
        vmiMaterials: vmiSlice
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(globalSyncMiddleware)
})